

import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";

const renderTestimonials = ($, $context = $(document)) => {
	const testimonialSwipers = $context.find(".testimonials-swiper").toArray();

	if (!testimonialSwipers.length) return;

	testimonialSwipers.forEach((swiperElement) => {
		if (swiperElement.classList.contains("swiper-initialized")) return;

		let wrapper = swiperElement.querySelector(":scope > .swiper-wrapper");

		if (!wrapper) {
			wrapper = document.createElement("div");
			wrapper.classList.add("swiper-wrapper");

			[...swiperElement.children].forEach((slide) => {
				wrapper.appendChild(slide);
			});

			swiperElement.appendChild(wrapper);
		}

		[...wrapper.children].forEach((slide) => {
			slide.classList.add("swiper-slide");
		});

		swiperElement.classList.add("swiper");

		const sliderParent = swiperElement.closest(".testimonials-block") || swiperElement.parentElement;
		const prevEl = sliderParent?.querySelector(".swiper__button.prev");
		const nextEl = sliderParent?.querySelector(".swiper__button.next");
		const modules = [A11y];
		const options = {
			modules,
			slidesPerView: 1,
			spaceBetween: 24,
		};

		if (prevEl && nextEl) {
			modules.push(Navigation);
			options.navigation = {
				prevEl,
				nextEl,
			};
		}

		new Swiper(swiperElement, options);
	});
};


export default renderTestimonials;
